import { pathOr } from 'ramda';
import { ESortVariants } from '../../types/jsonQuery/sortType';
import { IApplicationState } from '../../types/redux';

export const selectCurrentSorting = (state: IApplicationState) => {
  const { nextJsonQuery, sortVariants } = state;

  const currentSortKey: ESortVariants = pathOr(ESortVariants.Popularity, ['sort', 'value'], nextJsonQuery);
  const currentSort = sortVariants.find(({ key }) => key === currentSortKey);

  if (!currentSort) {
    return null;
  }

  return {
    label: currentSort.value,
    value: currentSort.key,
  };
};
